// extracted by mini-css-extract-plugin
export default {"container":"d0-z","list":"e0-z"};